// MARK: NPM Modules
import React from "react";

// MARK: React Components
// Props
interface LinkProps {
  dimension: number;
  color: string;
  mobile: boolean;
}
// Component
const Link = ({ dimension, color, mobile }: LinkProps) => {
  var viewBox: string = "";
  switch (mobile) {
    case true:
      viewBox = "0 0 19 9";
      break;
    case false:
      viewBox = "-5 -3.05 28.5 13.5";
      break;
  }
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      width={dimension}
      height={dimension}
    >
      <path
        d="m8.4,8.5h-3.9c-2.2,0-4-1.8-4-4h0C.5,2.3,2.3.5,4.5.5h3.85"
        stroke={color}
        fill={"none"}
        strokeMiterlimit={10}
      />
      <path
        d="m10.46.5h4.04c2.2,0,4,1.8,4,4h0c0,2.2-1.8,4-4,4h-4.04"
        stroke={color}
        fill={"none"}
        strokeMiterlimit={10}
      />
      <line
        x1="5.5"
        y1="4.5"
        x2="13.5"
        y2="4.5"
        stroke={color}
        fill={"none"}
        strokeMiterlimit={10}
        strokeWidth={2}
      />
    </svg>
  );
};

export default Link;
